<template>
  <div>
    <div class="modal is-active" v-show="showLogModal">
      <div class="modal-background"></div>
      <div class="modal-card" style="width:50%">
        <header class="modal-card-head">
          <p class="modal-card-title">
            Ticket Log # <strong>{{ ticketingForItemId }}</strong>
          </p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal"
          ></button>
        </header>
        <section class="modal-card-body">
          <br />
          <b-loading
            :is-full-page="false"
            :active.sync="isFetchingSavedInfo"
            :can-cancel="false"
          ></b-loading>
          <div class="timeline">
            <header class="timeline-header">
              <span class="tag is-medium is-info">Latest</span>
            </header>
            <template v-for="log in logs">
              <div class="timeline-item" :key="log.ticketingForItemLogId">
                <div class="timeline-marker is-info"></div>
                <div class="timeline-content">
                  <p class="heading">
                    <b-tag
                      v-if="log.progressStatus == 'Pending'"
                      style="font-size:9px;background-color:#E08A1E;color:white"
                      v-text="log.progressStatus"
                    ></b-tag>
                    <b-tag
                      v-if="log.progressStatus == 'In progress'"
                      style="font-size:9px;background-color:#22A7F0;color:white"
                      v-text="log.progressStatus"
                    ></b-tag>
                    <b-tag
                      v-if="log.progressStatus == 'Canceled'"
                      style="font-size:9px;background-color:#C91F37;color:white"
                      v-text="log.progressStatus"
                    ></b-tag>
                    <b-tag
                      v-if="log.progressStatus == 'Completed'"
                      style="font-size:9px;background-color:#26C281;color:white"
                      v-text="log.progressStatus"
                    ></b-tag>
                  </p>
                  <p class="log-detail">
                    <strong>Modified date</strong>: <i>{{ log.dateLog }}</i>
                  </p>
                  <p class="log-detail">
                    <strong>SOW</strong>: {{ log.ticketingSow }}
                  </p>
                  <p class="log-detail">
                    <strong>Item Type</strong>: {{ log.ticketingItemType }}
                  </p>
                  <p class="log-detail"><strong>QTY</strong>: {{ log.qty }}</p>
                  <p class="log-detail">
                    <strong>Clone</strong>: {{ log.clone }}
                  </p>
                  <p class="log-detail">
                    <strong>Branded</strong>: {{ log.branded }}
                  </p>
                  <p class="log-detail">
                    <strong>Date</strong>: {{ log.date }}
                  </p>
                  <p class="log-detail">
                    <strong>Assigned tech staff</strong>:
                    {{ log.assignedTechUser }}
                  </p>
                  <p class="log-detail">
                    <strong>Agent note</strong>: {{ log.agentNote }}
                  </p>
                  <p class="log-detail">
                    <strong>Tech note</strong>: {{ log.techNote }}
                  </p>
                </div>
              </div>
            </template>
            <header class="timeline-header">
              <span class="tag is-medium">Oldest</span>
            </header>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content:flex-end">
          <button class="button is-small" @click="closeModal">Close</button>
        </footer>
      </div>
    </div>
  </div>
</template>
<style>
.log-detail {
  font-size: 11px;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import {
  DateTimeFormatWithSecond,
  DayMonthYearFormatOnly
} from "../../helpers/momentFormat";

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  data: () => ({
    isFetchingSavedInfo: false,
    logs: []
  }),
  computed: {
    ...mapState("ticketingforitem", {
      showLogModal: state => state.showLogModal,
      ticketingForItemId: state => state.ticketingForItemId
    })
  },
  methods: {
    ...mapActions("ticketingforitem", ["openLogModal"]),
    getTicketingForItemLogById(id) {
      if (id) {
        this.isFetchingSavedInfo = true;
        axios
          .get(`api/ticketingforitems/history-logs/${id}`)
          .then(response => {
            response.data.forEach(d => {
              d.dateLog = DateTimeFormatWithSecond(d.dateLog);
              d.date = DayMonthYearFormatOnly(d.date);
            });

            this.logs = response.data;
          })
          .catch(error => {
            console.log(error);
          })
          .then(() => {
            this.isFetchingSavedInfo = false;
          });
      }
    },
    defaultData() {
      this.openLogModal({
        showLogModal: false
      });
      this.isFetchingSavedInfo = false;
      this.logs = [];
    },
    closeModal() {
      this.defaultData();
    }
  },
  watch: {
    ticketingForItemId() {
      if (this.ticketingForItemId) {
        this.getTicketingForItemLogById(this.ticketingForItemId);
      }
    }
  }
};
</script>
